import React from 'react';
import cn from '../../../utils/cn';
import { useCustomerDetails } from '../CustomerDetails/CustomerDetailsProvider';
import AddressCard from './AddressCard';

function AddressCont({ addressData }) {
    const { addressShow, customerDetailsData } = useCustomerDetails();
    return (
        <div
            className={cn(
                `flex gap-10 justify-around mb-5 transition-all duration-[600ms] ease-in-out overflow-hidden`,
                {
                    'max-h-0': !addressShow,
                    'max-h-[260px]': addressShow
                }
            )}
        >
            <AddressCard
                disabled={customerDetailsData?.status !== 'active'}
                title="administrative"
                addressData={addressData?.administrative}
            />
            <AddressCard
                disabled={
                    customerDetailsData?.status !== 'active' || customerDetailsData?.isBillToAgency
                }
                title="billing"
                addressData={addressData?.billing}
            />
            <AddressCard
                disabled={customerDetailsData?.status !== 'active'}
                title="technical"
                addressData={addressData?.technical}
            />
        </div>
    );
}

export default AddressCont;
